import { create } from 'zustand';

interface PageNotFoundState {
  loading: boolean;
  
  // Actions
  setLoading: (loading: boolean) => void;
  
  // Initialize loading state
  initializeLoading: () => void;
}

export const usePageNotFoundStore = create<PageNotFoundState>((set) => ({
  loading: true,
  
  setLoading: (loading) => set({ loading }),
  
  initializeLoading: () => set({ loading: true }),
}));
